import { useCallback, useEffect, useRef } from "react";

type UseInfiniteScrollOptions = {
  onLoad?: () => void;
  enabled?: boolean;
  threshold?: number;
};

export const useInfiniteScroll = ({
  onLoad,
  enabled = true,
  threshold = 80,
}: UseInfiniteScrollOptions) => {
  const containerRef = useRef<HTMLDivElement>(null);

  const handleScroll = useCallback(() => {
    const container = containerRef.current;
    if (!container || !enabled || !onLoad) return;

    const { scrollTop, scrollHeight, clientHeight } = container;
    const isNearBottom = scrollTop + clientHeight >= scrollHeight - threshold;

    if (isNearBottom) {
      onLoad();
    }
  }, [enabled, onLoad, threshold]);

  useEffect(() => {
    const container = containerRef.current;
    if (!container || !enabled || !onLoad) return;

    container.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      container.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll, enabled, onLoad]);

  return { containerRef };
};
